module.exports = __webpack_public_path__ + "img/wallet-report-blue.a32625db.svg";